interface PlaceholderPageProps {
  title: string;
}

/**
 * Page de substitution generique.
 * Utilisee comme cible de route catch-all (404) et pour les routes
 * en attente d'implementation.
 */
export function PlaceholderPage({ title }: PlaceholderPageProps) {
  return (
    <div className="flex h-full items-center justify-center p-8">
      <p className="font-sans text-sm text-muted">{title}</p>
    </div>
  );
}
